import axios from 'axios';

const EmailReminderService = {
  async createEmailReminder({
    meetingId,
    emails,
    subject,
    text,
    sendAt,
    type,
  }) {
    const response = await axios.post('/email-reminders', {
      meetingId,
      emails,
      subject,
      text,
      sendAt,
      type,
    });

    return response.data;
  },

  async updateReminder({ reminderId, emails, text, sendAt, subject }) {
    const response = await axios.put(`/email-reminders/${reminderId}`, {
      emails,
      text,
      sendAt,
      subject,
    });

    return response.data;
  },

  async getReminder({ meetingId }) {
    if (!meetingId) {
      throw new Error('meetingId is required');
    }
    const response = await axios.get(`/email-reminders/meeting/${meetingId}`);
    return response.data;
  },
};

export default EmailReminderService;
